import { createSelector } from 'reselect';
import type { RootState } from '../index';
import type { ProfileResponse } from '../../lib/api/profile-api-client';
import type {
  ProfileFetchStatus,
  ProfileUpsertStatus,
} from '../slices/profile-slice';

/**
 * Profile slice selectors (round-22 Phase D — realigned to the
 * shipped Smithy contract; email-confirm surface deleted).
 *
 * Pure projections of `state.profile` (plus one bridge into
 * `state.auth`) per design §3.1 (Selectors layer).
 */

export function selectProfile(state: RootState): ProfileResponse | undefined {
  return state.profile.profile;
}

export function selectProfileFetchStatus(
  state: RootState,
): ProfileFetchStatus {
  return state.profile.fetchStatus;
}

export function selectProfileUpsertStatus(
  state: RootState,
): ProfileUpsertStatus {
  return state.profile.upsertStatus;
}

export const selectIsAuthenticated = createSelector(
  [(state: RootState) => state.auth.status],
  (status): boolean => status === 'authenticated',
);

export const selectIsEmailConfirmed = createSelector(
  [(state: RootState) => state.profile.profile],
  (profile): boolean => profile?.emailConfirmed ?? false,
);
